import {
  useQuery,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'

import { scenarioQueryKeys } from '../queryKeys'
import { resourcefulScenarioRequest } from '../requests'
import { executeRequest } from '@utils/requests'

export function useNotesQuery({
  scenarioID,
  initialData,
  queryKey
}) {
  const queryClient = useQueryClient()
  // NOTE: We should contain a list of scenario resources
  // and reference notes from there
  const noteRequests = resourcefulScenarioRequest(
    scenarioID, 'notes'
  )

  const notesQuery = useQuery({
    queryFn: noteRequests.index,
    queryKey,
    initialData
  })

  const createNoteMutation = useMutation({
    mutationFn: noteRequests.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).notes] })
    },
  })
  const updateNoteMutation = useMutation({
    mutationFn: noteRequests.update,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).notes] })
    },
  })
  const deleteNoteMutation = useMutation({
    mutationFn: noteRequests.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).notes] })
    },
  })

  const importNotesMutation = useMutation({
    mutationFn: (params) => executeRequest(`/api/scenarios/${scenarioID}/notes/import`, 'POST', JSON.stringify(params)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).notes] })
    },
  })


  const isFetching = notesQuery.isFetching

  const isAnyLoading = notesQuery.isFetching ||
    createNoteMutation.isLoading

  return {
    data: notesQuery.data,
    actions: {
      create: createNoteMutation.mutateAsync,
      update: updateNoteMutation.mutateAsync,
      delete: deleteNoteMutation.mutateAsync,
      importSources: () => executeRequest(`/api/scenarios/${scenarioID}/notes/import_sources`),
      import: importNotesMutation.mutateAsync,
    },
    status: notesQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching,
    isAnyLoading: isAnyLoading
  }
}
